import { useState } from 'react';

const categories = [
  {
    title: 'Disability',
    description: 'Experience working with or supporting individuals with disabilities, inclusive program development, accessibility initiatives'
  },
  {
    title: 'Physical Disability',
    description: 'Specific experience with physical disabilities, mobility challenges, assistive technologies, or physical accessibility solutions'
  },
  {
    title: 'Economic Recovery',
    description: 'Experience in post-crisis economic recovery programs, livelihood restoration, financial resilience building'
  },
  {
    title: 'SMMEs Development',
    description: 'Supporting small, medium and micro enterprises, business development services, entrepreneurship training, access to finance'
  },
  {
    title: 'Rural Development',
    description: 'Rural community development projects, infrastructure improvement, rural livelihood programs, agricultural extension services'
  },
  {
    title: 'Access to Markets',
    description: 'Market linkage programs, value chain development, trade facilitation, e-commerce platforms for rural producers'
  },
  {
    title: 'Innovation',
    description: 'Developing or implementing innovative solutions, technology adoption, creative problem-solving in development contexts'
  },
  {
    title: 'Non',
    description: 'Developing or implementing innovative solutions, technology adoption, creative problem-solving in development contexts'
  },
];

const AreasFocus = ({ selectedAreas, onAreasChange, onSave }) => {
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [isExpanded, setIsExpanded] = useState(false);
  
  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  const handleSelect = (title) => {
    const newSelected = selectedAreas.includes(title)
      ? selectedAreas.filter(item => item !== title)
      : [...selectedAreas, title];
    
    onAreasChange(newSelected);
  };

  const handleSave = () => {
    if (onSave) {
      onSave(selectedAreas);
    }
  };

  return (
    <div className='md:mt-4'>
      {/* Heading */}
      <div 
        className="w-full md:h-[88px] h-[40px] flex items-center justify-between bg-[#152C24] rounded-[10px] md:mt-7 mt-3 relative cursor-pointer"
        onClick={toggleExpand}
      >
        <div className="md:w-[140px] md:h-[40px]"></div>
        <div className="absolute md:text-[32px] text-left text-white text-[8px] font-bold px-4">
          AREAS OF FOCUS
        </div>
        <div className="md:w-[154px] md:h-[88px] h-[40px] w-[80px] bg-[#D9D9D9] rounded-r-[10px] flex items-center justify-center">
          <img
            src="https://res.cloudinary.com/dzngpgki4/image/upload/v1748785688/Expand_down_yilqh4.png"
            alt="expand icon"
            className={`md:w-12 md:h-12 w-3 h-3 transition-transform duration-200 ${
              isExpanded ? 'transform rotate-180' : ''
            }`}
          />
        </div>
      </div>
      
      {/* Selectable Buttons */}
      {isExpanded && (
        <div>
          <p className="md:text-[32px] text-[8px] italic font-medium text-center md:mt-4 mt-2 md:mb-4">
            Do your activities address the following?
          </p>
          
          <div className="grid grid-cols-2 md:gap-x-0.5 gap-1 gap-y-2 md:mt-6 mt-2">
            {categories.map((category, i) => {
              const isActive = selectedAreas.includes(category.title);
              const isHovered = hoveredIndex === i;
              const isFirstColumn = i % 2 === 0;
              const isSecondColumn = i % 2 === 1;
              
              return (
                <div
                  key={i}
                  className={`relative overflow-hidden transition-all duration-500 ease-in-out 
                    ${isHovered ? 'md:h-[200px] h-[70px]' : 'md:h-[80px] h-[20px]'}
                    ${isFirstColumn ? 'rounded-l-[5px]' : ''}
                    ${isSecondColumn ? 'rounded-r-[5px]' : ''}
                    bg-[#F5F5F5]
                    transform 
                    transition-all duration-300 ease-in-out
                  `}
                  onMouseEnter={() => setHoveredIndex(i)}
                  onMouseLeave={() => setHoveredIndex(null)}
                >
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      handleSelect(category.title);
                    }}
                    className="w-full h-full flex flex-col justify-between text-left md:px-4 px-2 md:py-2 py-1"
                  >
                    <div className="flex justify-between items-center w-full">
                      <span className="font-medium text-[6px] md:text-[24px] leading-[1.10] md:w-[580px] w-[80%] truncate">
                        {category.title}
                      </span>
                      <div className="flex-shrink-0 ml-2">
                        <span
                          className={`
                            block md:w-14 md:h-14 w-3 h-3 rounded-full
                            ${isActive 
                              ? 'bg-[#25242C] md:border-[6px] border-[3px] border-white'
                              : 'md:border-[6px] border-[3px] border-white bg-[#D9D9D9]'}
                          `}
                        />
                      </div>
                    </div>
                    
                    {isHovered && (
                      <div className="overflow-hidden">
                        <p className="text-[6px] md:text-[20px] text-black">
                          {category.description}
                        </p>
                      </div>
                    )}
                  </button>
                </div>
              );
            })}
          </div>
          
          {/* Save Button */}
       
          <div className="flex justify-end mt-4">
  <button
 onClick={handleSave}

  className="flex items-center justify-center gap-2 h-[15px] md:h-[44px] md:text-[24px] text-[6px] font-normal italic rounded-[5px] mt-2"
  >
  Save
    <img
    src="https://res.cloudinary.com/dzngpgki4/image/upload/v1750801615/Import_lll7wj.png"
    alt="Save Icon"
    className="md:w-8 md:h-8 h-3 w-3"
  />
  </button>
</div>
        </div>
      )}
    </div>
  );
};

export default AreasFocus;